function displayNameFromEmail(email: string): string {
  const local = email.split('@')[0]?.split('+')[0]?.trim() || '';
  if (!local) return '';
  return local
    .replace(/[._-]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

function companyFromEmail(email: string): string {
  const domain = email.split('@')[1]?.trim().toLowerCase() || '';
  if (!domain) return '';
  const personal = new Set([
    'gmail.com',
    'googlemail.com',
    'yahoo.com',
    'outlook.com',
    'hotmail.com',
    'icloud.com',
    'proton.me',
    'protonmail.com',
  ]);
  if (personal.has(domain)) return 'Independent recruiter';
  const root = domain.split('.')[0] || '';
  return root.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

/** Normalize recruiter fields from Messages Hub v1 API payloads. */
export function parseHubRecruiterDisplay(recruiter: unknown): {
  name: string;
  company: string;
} {
  if (!recruiter || typeof recruiter !== 'object') {
    return { name: 'Recruiter', company: 'Independent recruiter' };
  }
  const r = recruiter as Record<string, unknown>;
  const first = String(r.firstName ?? r.first_name ?? '').trim();
  const last = String(r.lastName ?? r.last_name ?? '').trim();
  const email = String(r.email ?? '').trim();
  const nameField = String(r.name ?? r.fullName ?? '').trim();
  const name =
    nameField || `${first} ${last}`.trim() || displayNameFromEmail(email) || email || 'Recruiter';
  const company = String(r.company ?? r.companyName ?? r.company_name ?? '').trim();
  return {
    name,
    company: company || companyFromEmail(email) || 'Independent recruiter',
  };
}
